<template>
    <div>
        <label class="mr-1">Items Per Page</label>
        <select :value="value" @input="$emit('input', $event.target.value)" @change="$emit('change')" class="custom-select">
            <option v-for="(option, index) in options" :value="option" :key="index">{{ option }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: ['value'],
    data: function() {
        return {
            options: [20, 50, 100]
        }
    }
}
</script>

<style lang="scss" scoped>
select {
    height: calc(2.1rem + 2px);
    width: auto;
}
</style>